import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input/index.js';

const FiltersTableSchedules = ({ form, handleClear, setFormFilter, t, page, setPage }) => {
  const statusCategories = [
    { id: 'draft', value: t('draft') },
    { id: 'published', value: t('published') },
    { id: 'hidden', value: t('hidden') },
  ];

  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable 
      handleClear={handleClear} 
      multipleInput={true} 
      className="d-flex align-items-center"
    >
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={form.title}
          label={`${t('titulo')}`}
          onChange={(e) => handleSearch(e, 'title')}
          placeholder={t('titulo')}
          md={7}
        />
        <SelectInputCustom
          choices={statusCategories}
          label={`${t('state')}`}
          placeholder={t('state')}
          value={form.status || ''}
          onCheckedItem={(value) => {
            handleSearch(value, 'status');
          }}
          md={7}
        />
      </Form>
    </SearchTable>
  );
};

FiltersTableSchedules.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func,
};

export default FiltersTableSchedules;
